

import React, { useState, useRef, useEffect } from "react";
const ActionMenu = ({ onEdit, onDelete, onAdd ,onSave, onCancel,btnName1,btnName2,onNavigate1, onNavigate2}) => {
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef();

  const toggleMenu = () => setShowMenu(!showMenu);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="position-relative" ref={menuRef}>
      <button
        className="btn btn-light p-0 border-0"
        onClick={toggleMenu}
        style={{ fontSize: "24px", lineHeight: "1", background: "none" }}
      >
        &#8942; {/* vertical three dots */}
      </button>
      {showMenu && (
        <div className="position-absolute bg-white border rounded shadow p-2" style={{ zIndex: 100, right: "-30px", top: "-80%" }}>
        { onEdit &&
          <div
            className="dropdown-item  hover-edit"
            style={{ fontSize: "14px", fontWeight: "bold", cursor: "pointer" }}
            onClick={onEdit}
          >
            Edit
          </div>
        }
        {onDelete &&
          <div
            className="dropdown-item hover-remove"
            style={{ fontSize: "14px", fontWeight: "bold", cursor: "pointer" }}
            onClick={onDelete}
          >
            Remove
          </div>
        }
          {onAdd &&

            <div
              className="dropdown-item hover-remove"
              style={{ fontSize: "14px", fontWeight: "bold", cursor: "pointer" }}
              onClick={onAdd}
            >
              Add
            </div>
          }
           {onSave &&

            <div
              className="dropdown-item hover-remove"
              style={{ fontSize: "14px", fontWeight: "bold", cursor: "pointer" }}
              onClick={onSave}
            >
              Save
            </div>
          }
               {onCancel &&

            <div
              className="dropdown-item hover-remove"
              style={{ fontSize: "14px", fontWeight: "bold", cursor: "pointer" }}
              onClick={onSave}
            >
              Cancel
            </div>
          }

          {onNavigate1 &&

            <div
              className="dropdown-item hover-edit"
              style={{ fontSize: "14px", fontWeight: "bold", cursor: "pointer" }}
              onClick={onNavigate1}
            >
              {btnName1}
            </div>
          }

          {onNavigate2 &&

            <div
              className="dropdown-item hover-edit"
              style={{ fontSize: "14px", fontWeight: "bold", cursor: "pointer" }}
              onClick={onNavigate2}
            >
              {btnName2}
            </div>
          }
        </div>
      )}
    </div>
  );
};

export default ActionMenu;
